import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api, IMAGES } from "@/lib/data";
import { Reveal } from "@/components/Reveal";

export default function KnowledgeBank() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo({ top: 0 });
    api.get("/articles").then((r) => { setArticles(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const fmt = (d) => new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });

  return (
    <main data-testid="knowledge-page" className="pt-32 pb-24 min-h-screen bg-background">
      <div className="container-edge">
        <Reveal>
          <p className="overline mb-4">Insights & Resources</p>
          <h1 className="font-display font-light text-5xl md:text-7xl tracking-tight text-primary max-w-3xl mb-6">Knowledge Bank</h1>
          <p className="text-lg text-foreground/70 max-w-2xl mb-16">Practical perspectives on intellectual property — audits, valuation, trademarks, and beyond.</p>
        </Reveal>

        {loading ? (
          <p className="text-muted-foreground">Loading articles…</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {articles.map((a, i) => (
              <Reveal key={a.id} delay={(i % 3) * 0.08}>
                <Link data-testid={`article-card-${a.slug}`} to={`/knowledge/${a.slug}`} className="group block border border-border bg-card h-full transition-colors duration-500 hover:border-accent">
                  <div className="overflow-hidden h-52">
                    <img src={a.cover_image || IMAGES.document} alt={a.title} className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" />
                  </div>
                  <div className="p-7">
                    <div className="flex items-center justify-between mb-4">
                      <span className="overline">{a.category}</span>
                      <span className="text-xs text-muted-foreground">{fmt(a.created_at)}</span>
                    </div>
                    <h3 className="font-display text-2xl text-primary leading-snug mb-3 group-hover:text-accent transition-colors">{a.title}</h3>
                    <p className="text-sm text-foreground/65 leading-relaxed line-clamp-3">{a.excerpt}</p>
                    <span className="inline-flex items-center gap-1 mt-5 text-xs uppercase tracking-widest text-accent">Read <ArrowUpRight size={14} /></span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
